import { render, staticRenderFns } from "./OnlineOrderDeviceData.vue?vue&type=template&id=36bacc92&"
import script from "./OnlineOrderDeviceData.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderDeviceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports